export const staircaseConfig = {
    gameSlug: 'lost-in-migration',
    category: 'air_attention',
    variable: 'duration_ms',
    startValue: 600,
    minValue: 150,
    maxValue: 1500,
    stepSizesByPhase: [100, 50, 25, 12],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 32,
    direction: 'down-easier',
};
export const DIRECTIONS_2 = ['left', 'right'];
export const DIRECTIONS_4 = [
    'left',
    'right',
    'up',
    'down',
];
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            nDirections: 2,
            axis: 'horizontal',
            incongruentRatio: 0.5,
            label: 'Flanker base',
        };
    }
    if (level <= 20) {
        return {
            level,
            nDirections: 2,
            axis: 'horizontal',
            incongruentRatio: 0.5,
            label: 'Pression temporelle',
        };
    }
    if (level <= 30) {
        return {
            level,
            nDirections: 4,
            axis: 'mixed',
            incongruentRatio: 0.5,
            label: '4 directions',
        };
    }
    if (level <= 40) {
        return {
            level,
            nDirections: 4,
            axis: 'mixed',
            incongruentRatio: 0.6,
            label: 'Conflit accru',
        };
    }
    return {
        level,
        nDirections: 4,
        axis: 'mixed',
        incongruentRatio: 0.7,
        label: 'Filtrage expert',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 500,
    feedbackMs: 200,
    itiMs: 700,
    /** Fenêtre de réponse maximale après que le stimulus a disparu. */
    responseWindowMs: 1500,
};
export const paradigmMeta = {
    slug: 'lost-in-migration',
    paradigm: 'Eriksen Flanker Task (Eriksen & Eriksen 1974)',
    /** Internal only — non affiché. */
    masterMage: 'Inori · Volta',
    category: 'air_attention',
    goal: 'Attention sélective : viser la cible centrale, ignorer les flankers.',
};
//# sourceMappingURL=params.js.map